import { useState, type FormEvent } from 'react';
import { useSearchParams } from 'react-router';
import { ShareRef } from '@lc/contracts';
import { api } from '../api';
import { useI18n } from '../i18n';

/**
 * 預約: an email to hear when the game launches, and its launch gift. `ref` says where the visitor
 * came from (the page's `?ref=`, else `source`).
 */
export function PreregForm({ source, compact }: { source?: string; compact?: boolean }) {
  const { t, lang } = useI18n();
  const [params] = useSearchParams();
  const fromUrl = ShareRef.safeParse(params.get('ref'));
  const ref = fromUrl.success ? fromUrl.data : source;
  const [email, setEmail] = useState('');
  const [state, setState] = useState<'idle' | 'busy' | 'done' | 'error'>('idle');

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (state === 'busy') return;
    setState('busy');
    try {
      await api.prereg({ email: email.trim(), locale: lang, ...(ref ? { ref } : {}) });
      setState('done');
    } catch {
      setState('error');
    }
  };

  if (state === 'done') {
    return (
      <div className={`prereg prereg-done${compact ? ' compact' : ''}`} role="status">
        <b>{t('prereg.done.title')}</b>
        <p>{t('prereg.done.body')}</p>
      </div>
    );
  }
  return (
    <form className={`prereg${compact ? ' compact' : ''}`} onSubmit={(e) => void submit(e)}>
      {compact ? null : (
        <div className="prereg-head">
          <b>{t('prereg.title')}</b>
          <p>{t('prereg.body')}</p>
        </div>
      )}
      <div className="prereg-row">
        <label htmlFor="prereg-email" className="sr-only">
          {t('prereg.email')}
        </label>
        <input id="prereg-email" className="input" type="email" required autoComplete="email" inputMode="email" placeholder={t('prereg.email')} value={email} onChange={(e) => setEmail(e.target.value)} />
        <button className="btn btn-pink" disabled={state === 'busy'}>
          {t('prereg.submit')}
        </button>
      </div>
      {state === 'error' ? (
        <p className="error" role="alert">
          {t('prereg.error')}
        </p>
      ) : (
        <p className="prereg-note">{t('prereg.note')}</p>
      )}
    </form>
  );
}
